<img
  width="5"
  height="12"
  src="/assets/ccstudio/segment-start.png"
  (mousedown)="dragIn.emit($event)"
/>

<svg
  #rect
  width="56"
  height="12"
  viewBox="0 0 56 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="0" y="0.570068" width="56.5519" height="12" fill="#BEC0C2" />
</svg>
<img
  width="5"
  height="12"
  src="/assets/ccstudio/segment-end.png"
  (mousedown)="dragOut.emit($event)"
/>
